import { default as Endpoint } from '../../api/Endpoint';
import * as Constants from '../constants';

export function requestImportConfiguration() {
  return {
    type: Constants.REQUEST_IMPORT_CONFIGURATION
  };
}
export function receiveImportConfiguration(json, error) {
  return {
    type: Constants.RECEIVE_IMPORT_CONFIGURATION,
    data: json,
    error
  };
}

export function requestFtpImportConfiguration() {
  return {
    type: Constants.REQUEST_FTP_IMPORT_CONFIGURATION
  };
}
export function receiveFtpImportConfiguration(json, error) {
  return {
    type: Constants.RECEIVE_FTP_IMPORT_CONFIGURATION,
    data: json,
    error
  };
}

export function getImportConfiguration(importType, options = {}) {
  if (importType === 'DeImport') {
    return getDeImportConfiguration();
  } else if (importType === 'FtpImport') {
    return getFtpImportConfiguration();
  }
}

export function getDeImportConfiguration(options = {}) {
  const path = 'ecs/api/data_extension/import_configuration';
  return new Endpoint(
    path,
    requestImportConfiguration,
    receiveImportConfiguration
  )
    .withOptions(options)
    .call();
}

export function getFtpImportConfiguration(options = {}) {
  const path = 'ecs/api/ftp/import_configuration';
  return new Endpoint(
    path,
    requestFtpImportConfiguration,
    receiveFtpImportConfiguration
  )
    .withOptions(options)
    .call();
}
